module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Chapter1"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "pg_15_1",
      "src": "images/pg_15_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Hitler’s Blitzkrieg through northern France in May 1940 proved unstoppable, as this wrecked Char B1 tank testifies; the swift defeat of the French Army that summer gave Mussolini a free hand to attack British interests in North Africa. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s Collection")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-498c0dfb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_02_Chapter1.vue
// module id = 81
// module chunks = 0